import BaseEntityNew from 'client/components/core/BaseEntity/BaseEntityNew'
import ChildrenEntities from 'client/components/core/ChildrenEntities'
import { useBackgroundImage } from 'client/hooks/useBackgroundImage'
import { useWebsiteSettings } from 'client/store'
import React from 'react'
import {
  getWebsiteStylesLayout,
  getWebsiteThemeBackground,
} from 'src/editor/store/website-settings/website-settings-selector'
import { CommonWebsitePageBody } from 'src/shared/entities/website-page-body'
import { WebsitePageInterface } from 'src/shared/types/website-entities'

export interface WebsitePageBodyProps {
  entity: WebsitePageInterface
  isMoveUpAllowed: boolean
  isMoveDownAllowed: boolean
}

export const WebsitePageBody = ({ entity }: WebsitePageBodyProps) => {
  const layout = useWebsiteSettings(getWebsiteStylesLayout)
  const background = useWebsiteSettings(getWebsiteThemeBackground)

  const { backgroundImage, mobileBackgroundImage } = useBackgroundImage({
    backgroundFileId: background?.pageBackgroundPicture?.file?.id,
    mobileBackgroundFileId: background?.pageBackgroundPicture?.file?.id,
  })

  return (
    <BaseEntityNew
      entity={entity}
      isMoveUpAllowed={false}
      isMoveDownAllowed={false}
      isCopyAllowed={false}
      isRemoveAllowed={false}
      isSaveAllowed={false}
    >
      <CommonWebsitePageBody
        htmlAttrId={entity.htmlAttrId}
        contentWidth={layout?.contentWidth}
        backgroundImage={backgroundImage}
        mobileBackgroundImage={mobileBackgroundImage}
        background={background?.contentBackgroundColor}
        mobileBackground={background?.contentBackgroundColor}
        pageBackground={background?.pageBackgroundColor}
        pageMobileBackground={background?.pageBackgroundColor}
      >
        <ChildrenEntities
          id={entity.id}
          childIds={entity.childIds}
          type={entity.type}
        />
      </CommonWebsitePageBody>
    </BaseEntityNew>
  )
}
